import { createAction, props } from '@ngrx/store';
import { QcResponse } from 'src/app/shared/models/qcResponse.model';

export const PanelStatusChanged = createAction('[Checkbooks: Search Group Templates]: Panel Status Changed');

export const CodeChanged = createAction(
  '[Checkbooks: Search Group Templates]: Code Changed',
  props<{ code: string }>(),
);

export const RemarksChanged = createAction(
  '[Checkbooks: Search Group Templates]: Remarks Changed',
  props<{ remarks: string }>(),
);

export const InactiveChanged = createAction(
  '[Checkbooks: Search Group Templates]: Inactive Changed',
  props<{ inactive: boolean }>(),
);

export const GetGroupTemplates = createAction('[Checkbooks: Search]: Get Group Templates');

export const GetGroupTemplatesSuccess = createAction(
  '[Checkbooks: Search Group Templates]: Get Group Templates Success',
  props<{ response: QcResponse }>(),
);

export const GetGroupTemplatesFailed = createAction(
  '[Checkbooks: Search Group Templates]: Get Group Templates Failed',
  props<{ error: any }>(),
);

export const ClearSearchGroupTemplatesFilters = createAction(
  '[Checkbooks: Search Group Templates]: Clear Group Templates Filters',
);

export const ChangeGroupTemplatesStatus = createAction(
  '[Checkbooks: Search Group Templates]: Change Group Templates Status',
  props<{ data: any }>(),
);

export const ChangeGroupTemplatesStatusFailed = createAction(
  '[Checkbooks: Search Group Templates]: Change GroupTemplates Failed',
  props<{ error: any }>(),
);

export const ChangeGroupTemplatesStatusSuccess = createAction(
  '[Checkbooks: Search Group Templates]: Changed GroupTemplates Success',
  props<{ res: any }>(),
);

export const DeactivateGroupTemplate = createAction(
  '[Checkbooks: Search Group Templates]: Deactivate Group Template',
  props<{ selectedRow: any }>(),
);

export const ActivateGroupTemplate = createAction(
  '[Checkbooks: Search Group Templates]: Activate Group Template',
  props<{ selectedRow: any }>(),
);

export const OpenConfirmDialogForDeactivateGroupTemplate = createAction(
  '[Checkbooks: Search Group Templates]: Open Confirm Dialog For Deactivate Group Template',
  props<{ selectedRow: any }>(),
);

export const CreateNewGroupTemplate = createAction(
  '[Checkbooks: Search Group Templates]: Create New Checkbook Group Template',
);

export const UpdateGroupTemplate = createAction(
  '[Checkbooks: Search Group Templates]: Update Checkbook Group Template',
);
